var _ellipse, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.106,
    cy: 47.3099,
    rx: 12.2652,
    ry: 12.265,
    fill: "#F97330"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.9712 17.7527C80.0005 11.6941 77.5448 4.32686 71.4861 1.29754C65.4273 -1.73178 58.06 0.723965 55.0306 6.78261L39.377 38.0895L53.0328 65.5346C53.0503 65.531 53.0678 65.5275 53.0852 65.524L76.9712 17.7527Z",
    fill: "#605DEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.308 130.657C131.334 127.582 133.733 120.206 130.665 114.173L123.685 100.446C123.524 100.028 123.339 99.6143 123.128 99.2072C122.745 98.4649 122.347 97.731 121.936 97.0057L121.905 96.9437C121.676 96.4945 121.424 96.0653 121.15 95.657C112.034 80.4421 96.9896 69.3322 79.0664 65.6406L108.673 125.043L108.799 125.291C110.904 129.431 115.036 131.863 119.372 131.994C119.554 132 119.736 132.001 119.919 131.999C121.704 131.972 123.512 131.554 125.216 130.702C125.246 130.687 125.277 130.672 125.308 130.657Z",
    fill: "#F97330"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7057 88.9431L53.0273 65.5372C57.1426 64.7058 61.4092 64.2695 65.7909 64.2695C70.3434 64.2695 74.7836 64.7426 79.0666 65.6418L100.632 108.913C93.6678 96.4997 80.6234 88.9285 65.7909 88.9285C65.4281 88.9285 65.0663 88.9334 64.7057 88.9431Z",
    fill: "#2CDDD8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3769 38.0889L9.35647 98.1289C8.68923 99.3591 8.0593 100.613 7.46813 101.89C7.44165 101.947 7.4156 102.004 7.39 102.062L1.29755 114.247C-1.73181 120.305 0.723975 127.672 6.7827 130.702C12.8414 133.731 20.2088 131.275 23.2381 125.217L32.099 107.495C34.4145 103.873 37.2801 100.653 40.573 97.955L29.4318 75.6256C36.4254 70.7586 44.4304 67.2615 53.1067 65.52C52.0865 63.4693 51.8051 62.9202 51.4189 62.1665C50.5963 60.5613 49.2983 58.0285 39.3769 38.0889Z",
    fill: "#4B4BB7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.573 97.9546L29.4316 75.6251C36.4252 70.7581 44.4303 67.261 53.1066 65.5195L64.7917 88.939C55.6485 89.1657 47.236 92.4943 40.573 97.9546Z",
    fill: "#42A6E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.52ce7a03a7857259c41fe3eb65f1bf2c.svg";
export { ForwardRef as ReactComponent };